<script>
import { layoutComputed } from '@/state/helpers'
import Vertical from './vertical'
import { API_URL } from '../../config/HTTP'

export default {
  components: {
    Vertical,
  },
  data() {
    return {}
  },
  computed: {
    ...layoutComputed,
  },
  methods: {},
  mounted() {
    document.querySelector('html').setAttribute('dir', 'rtl')
  },
}
</script>

<template>
  <div>
    <vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot>
        <router-view></router-view>
      </slot>
    </vertical>
  </div>
</template>

<style scoped>
::v-deep .page-content {
  padding-bottom: 0 !important;
}
::v-deep .page-title-box {
  padding-bottom: 12px !important;
}
</style>
